/* eslint-disable react/prop-types */
import React, { useState, useEffect, useRef, useMemo } from "react";
// Material Dashboard 2 React components
import {
  IconButton,
  TextField,
  Button,
  Alert,
  Box,
  Grid,
  Dialog,
  FormHelperText,
  Select,
  MenuItem,
  FormControl,
  Typography,
  Autocomplete,
} from "@mui/material";
import { Cancel } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { useMaterialUIController } from "context";
// import themeLight from "assets/theme";
// import themeDark from "assets/theme-dark";
import MDBox from "components/MDBox";
// import CssBaseline from "@mui/material/CssBaseline";
import { createTheme } from "@mui/material/styles";
import colors from "assets/theme/base/colors";
import { MenuProps } from "utils/constants";
import { API_ROUTES, validateArrayFileRequired } from "utils/constants";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { useRecoilValue } from "recoil";
import { SettingState } from "states";

const defaultValue = {
  maphuong: null,
  maquan: null,
  gioitinh: "M",
  first_name: "",
  last_name: "",
  username: "",
  password: "",
  repassword: "",
  birth_date: null,
  is_active: false,
  gender: "M",
  address: "",
  donvi: "",
};

const CRUDUser = ({
  open,
  data,
  onClose,
  onSubmit,
  title,
  validationErrors,
  dataGroup,
  dataHuyen,
}) => {
  const [controller, dispatch] = useMaterialUIController();
  const [alert, setAlert] = useState({
    alert: false,
    message: null,
    type: null,
  });
  const { darkMode } = controller;
  const themeLight = createTheme({
    palette: {
      primary: {
        main: colors.info.main,
      },
      background: {
        default: colors.background.default,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const themeDark = createTheme({
    palette: {
      mode: "dark",
      primary: {
        main: colors.info.main,
      },
      secondary: {
        main: colors.secondary.main,
      },
    },
  });
  const [errors, setErrors] = useState({
    first_name: "",
    last_name: "",
    username: "",
    birth_date: "",
    password: "",
    repassword: "",
    email: "",
    picture: [],
  });
  const [dataState, setDataState] = useState(defaultValue);
  const axiosPrivateInstance = useAxiosPrivate();
  const [optionSubDitrict, setOptionSubDitrict] = useState([]);
  const settingState = useRecoilValue(SettingState);

  const formRef = useRef(null);
  const [values, setValues] = useState({
    showPass: false,
  });
  const [revalues, setReValues] = useState({
    showPass: false,
  });

  const [group, setGroup] = useState([]);
  const dicGroup = useMemo(() => {
    let dic = {};
    dataGroup?.map((item, index) => {
      dic[item?.id] = {
        id: item?.id,
        name: item?.name,
      };
    });
    return dic;
  }, [dataGroup]);

  async function onSubmitForm(event) {
    event.preventDefault();
    onSubmit({ id: data.id });
    setErrors({});
  }
  const getSubditrict = async (code) => {
    try {
      const response = await axiosPrivateInstance.get(
        API_ROUTES.GETXA + "?huyen=" + code
      );
      setOptionSubDitrict(response?.data);
    } catch (error) {
      console.log(error);
      return;
    }
  };

  const handelClear = () => {
    onClose();
    setErrors([]);
  };

  useEffect(() => {
    if (validationErrors?.another) {
      setAlert({
        alert: true,
        message: validationErrors?.another,
        type: "error",
      });
    } else {
      setErrors(validationErrors);
    }
  }, [validationErrors]);

  useEffect(() => {
    if (data?.id) {
      setDataState(data);
      setGroup(data?.group);
      getSubditrict(data?.maquan);
    } else {
      setGroup([]);
      setDataState(defaultValue);
    }
  }, [data]);

  useEffect(() => {
    if (open) {
      setReValues(false);
      setValues(false);
      setErrors([]);
    }
  }, [open]);

  const handlePassVisibilty = () => {
    setValues({
      ...values,
      showPass: !values.showPass,
    });
  };
  const handleRePassVisibilty = () => {
    setReValues({
      ...revalues,
      showPass: !revalues.showPass,
    });
  };
  const handleChangeGroup = (e, newValue) => {
    setGroup(newValue);
  };
  const handleChangeDistrict = (e) => {
    const value = e.target.value;
    setDataState((prev) => {
      return {
        ...prev,
        maquan: value,
        maphuong: "",
      };
    });
    getSubditrict(value);
  };
  const handleChangeValueInput = (name) => (e) => {
    let { value } = e.target;
    setDataState((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };
  const handleOnFocus = (name) => (e) => {
    e.stopPropagation();
    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };
  return (
    // <ThemeProvider theme={darkMode ? themeDark : themeLight}>
    <Dialog open={open} maxWidth={"md"}>
      <form ref={formRef} method="post" encType="multipart/form-data">
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {title ? title : "Tài khoản người dùng"}
          <IconButton
            aria-label="close"
            onClick={handelClear}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers>
          <MDBox sx={{ p: 1 }}>
            {errors && errors.error ? (
              <Grid container sx={{ textAlign: "center", mb: 0 }}>
                <Grid item xs={12}>
                  <Alert severity="error" sx={{ mb: 3, mt: 0 }}>
                    {errors.error}
                  </Alert>
                </Grid>
              </Grid>
            ) : (
              ""
            )}
            <Grid container spacing={2} sx={{ textAlign: "left" }}>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Huyện <span style={{ color: "red" }}>*</span>
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    required
                    sx={{ padding: "0.7rem" }}
                    labelId="label-huyen"
                    name="maquan"
                    displayEmpty
                    disabled
                    MenuProps={MenuProps}
                    error={errors ? !!errors.maquan : false}
                    value={dataHuyen?.length > 0 ? dataState?.maquan || "" : ""}
                  >
                    <MenuItem value={""}>-- Chọn quận huyện --</MenuItem>
                    {dataHuyen &&
                      dataHuyen?.length > 0 &&
                      dataHuyen.map((item) => (
                        <MenuItem key={item.ma + "key_maquan"} value={item.ma}>
                          {item?.ten}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors && (
                    <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                      {errors.maquan}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Phường/Xã
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    required
                    sx={{ padding: "0.7rem" }}
                    labelId="label-phuong"
                    name="maphuong"
                    displayEmpty
                    MenuProps={MenuProps}
                    error={errors ? !!errors.maphuong : false}
                    disabled
                    value={
                      optionSubDitrict?.length > 0
                        ? dataState?.maphuong || ""
                        : ""
                    }
                  >
                    <MenuItem value={""}>-- Chọn phường xã --</MenuItem>
                    {optionSubDitrict &&
                      optionSubDitrict?.length > 0 &&
                      optionSubDitrict.map((item) => (
                        <MenuItem
                          key={item.ma + "key_maphuong"}
                          value={item.ma}
                        >
                          {item?.ten}
                        </MenuItem>
                      ))}
                  </Select>
                  {errors && (
                    <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                      {errors.maphuong}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Họ lót <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  disabled
                  fullWidth
                  required
                  name="first_name"
                  error={errors ? !!errors.first_name : false}
                  helperText={errors?.first_name}
                  value={dataState?.first_name || ""}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tên <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  disabled
                  required
                  name="last_name"
                  error={errors ? !!errors.last_name : false}
                  helperText={errors?.last_name}
                  value={dataState?.last_name || ""}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Tài khoản <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  fullWidth
                  required
                  disabled
                  name="username"
                  error={errors ? !!errors.username : false}
                  helperText={errors?.username}
                  value={dataState?.username || ""}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Email <span style={{ color: "red" }}>*</span>
                </Typography>
                <TextField
                  required
                  disabled
                  fullWidth
                  name="email"
                  error={errors ? !!errors.email : false}
                  helperText={errors?.email}
                  value={dataState?.email || ""}
                />
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Ngày sinh
                </Typography>
                <TextField
                  type="date"
                  fullWidth
                  disabled
                  name="birth_date"
                  error={errors ? !!errors.birth_date : false}
                  helperText={errors?.birth_date}
                  value={dataState?.birth_date || ""}
                />
              </Grid>
              <Grid item xs={6} sx={{ textAlign: "left" }}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Giới tính <span style={{ color: "red" }}>*</span>
                </Typography>
                <FormControl fullWidth size="small">
                  <Select
                    required
                    sx={{ padding: "0.7rem" }}
                    labelId="label-gioitinh"
                    value={dataState?.gender || "M"}
                    name="gender"
                    error={errors ? !!errors.gender : false}
                    disabled
                  >
                    <MenuItem value="M">Nam</MenuItem>
                    <MenuItem value="F">Nữ</MenuItem>
                    <MenuItem value="O">Khác</MenuItem>
                  </Select>
                  {errors && (
                    <FormHelperText sx={{ color: "red", fontSize: "12px" }}>
                      {errors.gender}
                    </FormHelperText>
                  )}
                </FormControl>
              </Grid>
              <Grid item xs={6}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Địa chỉ
                </Typography>
                <TextField
                  fullWidth
                  name="address"
                  value={dataState?.address || ""}
                  disabled
                />
              </Grid>
              <Grid item xs={12}>
                <Typography
                  fontSize={"0.75rem"}
                  color={"#000000"}
                  fontWeight={500}
                >
                  Nhóm người dùng <span style={{ color: "red" }}>*</span>
                </Typography>
                <Autocomplete
                  id="combo-box-group"
                  options={Object.values(dicGroup)}
                  sx={{
                    width: "100%",
                    ".MuiAutocomplete-tag": {
                      backgroundColor: "#1A73E8",
                      color: "#ffffff",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="Chọn Nhóm người dùng"
                      error={errors ? !!errors.group : false}
                      helperText={errors.group}
                    />
                  )}
                  disabled
                  value={group}
                  getOptionLabel={(option) => option.name}
                  isOptionEqualToValue={(option, value) =>
                    option.id === value.id
                  }
                  renderOption={(props, options) => (
                    <Box component="li" {...props} key={options.id}>
                      {options.name}
                    </Box>
                  )}
                  multiple
                />
              </Grid>
            </Grid>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            type="button"
            variant="contained"
            startIcon={<Cancel />}
            size="small"
            onClick={handelClear}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Hủy
          </Button>
          <Button
            type="submit"
            variant="contained"
            startIcon={<SaveIcon />}
            size="small"
            onClick={onSubmitForm}
            sx={{ color: "#ffffff", float: "right", mr: 1 }}
          >
            Phê duyệt
          </Button>
        </DialogActions>
      </form>
    </Dialog>
    // </ThemeProvider>
  );
};

const validateRequired = (value) => !!value.length;

function validateOBJ(user, visible, dungluong) {
  if (visible) {
    return {
      maquan: !validateRequired(user.maquan) ? "Chọn Huyện" : "",
      first_name: !validateRequired(user.first_name)
        ? "Họ lót không được trống"
        : "",
      last_name: !validateRequired(user.last_name)
        ? "Tên không được trống"
        : "",
      username: !validateRequired(user.username)
        ? "Tên tài khoản không được trống"
        : "",
      password: !validateRequired(user.password)
        ? "Mật khẩu không được trống"
        : "",
      repassword: !validateRequired(user.repassword)
        ? "Xác nhận mật khẩu không được trống"
        : "",
      email: !validateRequired(user.email) ? "Email không được trống" : "",
      picture: validateArrayFileRequired(user.picture, dungluong),
    };
  } else {
    return {
      maquan: !validateRequired(user.maquan) ? "Chọn Huyện" : "",
      first_name: !validateRequired(user.first_name)
        ? "Họ lót không được trống"
        : "",
      last_name: !validateRequired(user.last_name)
        ? "Tên không được trống"
        : "",
      username: !validateRequired(user.username)
        ? "Tên tài khoản không được trống"
        : "",
      email: !validateRequired(user.email) ? "Email không được trống" : "",
      picture: validateArrayFileRequired(user.picture, dungluong),
    };
  }
}

export default CRUDUser;
